import React from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  Message,
  Modal,
  Text,
  toast,
} from '@workwhile/ui'
import { useSwitchTiersFlowContextValue } from '../context/SwitchTiersFlowProvider'

export const SwitchTiersFlowMain = () => {
  const {
    state: {
      mutationState: { isPending, isError, errorMessage },
    },
    actions: { transitionToNextTier, close },
  } = useSwitchTiersFlowContextValue()

  const handleTransitionToNextTier = () => {
    transitionToNextTier(undefined, {
      onSuccess: () => {
        toast.success(`Transitioned to next tier successfully`, {
          position: 'top-center',
        })
        close()
      },
    })
  }

  return (
    <Modal
      // 'open' is controlled by Parent component so we set it to true at all times. Instead we just unmount the component when it's closed
      open={true}
      onClose={close}
      position="top"
      loading={isPending}
      showCancel
      customCta={
        <Flex>
          <Button variant="text" onClick={close}>
            Cancel
          </Button>
          <Button onClick={handleTransitionToNextTier}>Confirm</Button>
        </Flex>
      }
    >
      <Box
        as="form"
        onSubmit={(e) => {
          e.preventDefault()
          handleTransitionToNextTier()
        }}
      >
        <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
          Are you sure?
        </Heading>

        <Text mt={3}>
          You're about to transition the listing for this shift to the next
          tier.
        </Text>
        <Message mt={4} variant="warning">
          This action is permanent and cannot be undone.
        </Message>

        {isError ? (
          <Message mt={3} variant="error">
            {errorMessage}
          </Message>
        ) : null}
      </Box>
    </Modal>
  )
}
